import { SignalSection } from "./TopologySections";
import { useBackbonePayload } from "./useBackbonePayload";
import { AuditWindowControls, useAuditHistory } from "./AuditHistory";
import { BACKBONE_LOADING, BACKBONE_PENDING, BACKBONE_UNAVAILABLE } from '../lib/definitions/topology';
import { type AuditWindow } from '../lib/definitions/analysis';

// Signal tab (2026-10-07): its own tab, reading the backbone snapshot payload
// (the same route as Topology, no new route or snapshot kind).
export function SignalTab({ windowKey, onWindowChange }: { windowKey: AuditWindow; onWindowChange: (w: AuditWindow) => void }) {
  const { takenAt } = useAuditHistory();
  const data = useBackbonePayload(windowKey, takenAt);
  const ok = data && data !== "unavailable" && data !== "pending";
  return (
    <section className="page-section">
      <div className="node-list-toolbar">
        <AuditWindowControls windowKey={windowKey} onWindowChange={onWindowChange} />
      </div>
      {data === null && <div className="node-detail-note">{BACKBONE_LOADING}</div>}
      {data === "pending" && <div className="node-detail-note">{BACKBONE_PENDING}</div>}
      {data === "unavailable" && <div className="node-detail-note">{BACKBONE_UNAVAILABLE}</div>}
      {ok && <SignalSection signal={data.signal} windowKey={windowKey} />}
    </section>
  );
}
